(function() {

    /* globals $, app */

    'use strict';

    $(function() {

        $('body').on('keyup', '#modal', 'form.contact-search input', function(e) {

            app.delayExecution(function() {

                var element = e.target,
                    form = element.form,
                    formElements,
                    data;

                if(!$(form).data('search')) {
                    return;
                }

                formElements = $(form.elements).not('option, input[type="checkbox"], input[type="hidden"], input.selectized');

                formElements = formElements.filter(function(_, element) {
                    return element.nodeName !== 'SELECT' && $(element).val();
                });

                // Rewrite all contact data attributes to search using the contact_details field on the contacts model

                formElements = formElements.map(function(_, element) {

                    var namePrefix = 'contact[contact_data_attributes]';

                    if(element.getAttribute('name').substr(0, namePrefix.length) !== namePrefix) {
                        return element;
                    }

                    element = element.cloneNode();
                    element.setAttribute('name', 'contact[contact_details][]');

                    return element;

                });

                data = formElements.serialize();

                // Do nothing if all user input fields are empty

                if(data === '') {

                    $('#contact-search-result').empty();
                    return;
                    
                }

                $.ajax({
                    url: form.action,
                    type: 'GET',
                    data: data,
                    dataType: 'script'
                });

            }, 450);

        });

    });

})();

